import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, pageSize } from "@/mixins/index";
import addActivateCode from './component/addActivateCode.vue';
export default {
  name: "activationCode",
  props: ['eventId'],
  mixins: [loadMoreList, pageSize],
  components: {
    addActivateCode: addActivateCode
  },
  data: function data() {
    return {
      pagingReqFn: "activationCodeList",
      paramsData: {
        page: 1
      },
      tableData: [],
      total: 0
    };
  },
  created: function created() {
    this.getList(1);
  },
  methods: {
    getList: function getList(page) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.paramsData.page = page;

                _this.$api.activationCodeList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  event_id: _this.eventId
                })).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    _this.tableData = data;
                    _this.total = res.data.total;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该激活码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$api.activationCodeDelete({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.$message.success("删除成功!");

                    _this2.getList(_this2.paramsData.page);
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    exportDataFn: function exportDataFn() {
      var _this3 = this;

      this.columns = [{
        label: 'ID',
        prop: 'id'
      }, {
        label: '设备激活码',
        prop: 'code'
      }, {
        label: '使用状态',
        prop: 'is_used_status'
      }, {
        label: '创建时间',
        prop: 'created_at'
      }];
      this.$api.activationCodeList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          data.forEach(function (item) {
            item.is_used_status = item.is_used == 0 ? '未使用' : '已使用';
          });

          _this3.$export.excel({
            columns: _this3.columns,
            data: data,
            title: '设备激活码'
          });
        }
      });
    }
  }
};